export default __webpack_public_path__ + "static/screenshot-59151936e731361cf7783b2df09011a2.png";